import moment from 'moment';

/** Sri Lanka — Asia/Colombo (UTC+05:30, no DST) */
export const SRI_LANKA_UTC_OFFSET = '+05:30';

export const toSriLankaMoment = (value) => {
  if (!value) {
    return null;
  }

  return moment.utc(value).utcOffset(SRI_LANKA_UTC_OFFSET);
};

export const formatSriLankaDate = (value) => {
  const sriLankaTime = toSriLankaMoment(value);

  return sriLankaTime ? sriLankaTime.format('DD/MM/YYYY') : '—';
};

export const formatSriLankaDateTime = (value) => {
  const sriLankaTime = toSriLankaMoment(value);

  return sriLankaTime ? sriLankaTime.format('DD/MM/YYYY HH:mm') : '—';
};

/** UTC midnight ISO string for API, from a picker value shown in Sri Lanka time */
export const toApiUtcDateTime = (momentValue) => {
  if (!momentValue) {
    return undefined;
  }

  const dateStr = momentValue.clone().utcOffset(SRI_LANKA_UTC_OFFSET, true).format('YYYY-MM-DD');

  return `${dateStr}T00:00:00Z`;
};
